export const IDENTIFICACAO_TITULO = 'Identificação';
export const NOME = 'Nome';
export const CPF = 'CPF';
export const RG = 'RG';
export const MATRICULA = 'Matrícula';
export const DATA_NASCIMENTO = 'Data Nascimento';
export const EMAIL = 'E-mail';
export const STATUS_USUARIO = 'Status';
export const FILIAL = 'Filial';
